import { render } from "./AccountRecovery.vue?vue&type=template&id=c4bc99d2&scoped=true"
import script from "./AccountRecovery.vue?vue&type=script&lang=js"
export * from "./AccountRecovery.vue?vue&type=script&lang=js"

import "./AccountRecovery.vue?vue&type=style&index=0&id=c4bc99d2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4bc99d2"]])

export default __exports__